import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  org: {},
  loading: false,
  error: null,
};

const orgSlice = createSlice({
  name: 'org',
  initialState,
  reducers: {
    fetchOrgRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchOrgSuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      state.org = action.payload;
    },
    fetchOrgFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.org = initialState.org;
    },
  },
});

export const { fetchOrgRequest, fetchOrgFailure, fetchOrgSuccess } = orgSlice.actions;

export default orgSlice.reducer;
